import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  MenuOutlined,
  CloseOutlined,
  LoginOutlined,
  UserAddOutlined,
} from "@ant-design/icons";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);

  const closeMenu = () => setShowMenu(false);

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50">

        <div className="mx-auto max-w-7xl px-5 py-4">

          <div className="flex items-center justify-between rounded-2xl border border-white/10 bg-slate-950/80 backdrop-blur-xl px-6 py-4 shadow-2xl">

            {/* Logo */}

            <Link
              to="/home"
              className="flex items-center gap-3"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-red-600 to-orange-500 text-white font-black text-lg shadow-lg">
                S
              </div>

              <div>

                <h2 className="text-xl font-black tracking-tight text-white">
                  SupaRecords
                </h2>

                <p className="text-xs text-slate-400">
                  Inventory & Accounting
                </p>

              </div>

            </Link>

            {/* Desktop */}

            <div className="hidden md:flex items-center gap-4">

              <a
                href="https://admin.suparecords.ng/auth"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 px-6 py-3 text-white transition duration-300 hover:bg-white/10"
              >
                <LoginOutlined />
                Login
              </a>

              <a
                href="https://admin.suparecords.ng/auth/signup"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-red-600 to-orange-500 px-7 py-3 font-semibold text-white shadow-lg transition duration-300 hover:scale-105 hover:shadow-red-500/40"
              >
                <UserAddOutlined />
                Start Free
              </a>

            </div>

            {/* Mobile */}

            <button
              onClick={() => setShowMenu(!showMenu)}
              className="md:hidden flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-white"
            >
              {showMenu ? (
                <CloseOutlined />
              ) : (
                <MenuOutlined />
              )}
            </button>

          </div>

        </div>

        {/* Mobile Menu */}

        <div
          className={`md:hidden transition-all duration-300 overflow-hidden ${
            showMenu
              ? "max-h-96 opacity-100"
              : "max-h-0 opacity-0"
          }`}
        >
          <div className="mx-5 rounded-2xl border border-white/10 bg-slate-950/95 backdrop-blur-xl p-5 shadow-2xl">

            <a
              href="https://admin.suparecords.ng/auth"
              target="_blank"
              rel="noreferrer"
              onClick={closeMenu}
              className="mb-3 flex items-center justify-center gap-2 rounded-xl border border-white/10 bg-white/5 py-4 text-white transition hover:bg-white/10"
            >
              <LoginOutlined />
              Login
            </a>

            <a
              href="https://admin.suparecords.ng/auth/signup"
              target="_blank"
              rel="noreferrer"
              onClick={closeMenu}
              className="flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-red-600 to-orange-500 py-4 font-semibold text-white transition hover:scale-[1.02]"
            >
              <UserAddOutlined />
              Start Free
            </a>

          </div>
        </div>

      </nav>

      {/* Spacer */}

      <div className="h-28" />
    </>
  );
};

export default Navbar;